import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

const Webinars = () => {
  const title = "Webinars";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const webinars = [
    {
      img: "assets/images/webinars/fca-supervision-2009-to-today-recap.jpg",
      alt: "FCA supervision of Money Service Businesses since 2009 with Mr. James Borley",
      link: "/fca-supervision-2009-to-today",
      title: "FCA Supervision of MSBs Since 2009",
      desc: "On 20th August, attendees from across the MSB industry joined an insightful session led by Mr. James Borley, Director for Payment Services at Complyport, exploring how FSA/FCA supervision of Money Service Businesses has evolved since 2009...",
    },
    {
      img: "assets/images/webinars/hmrc-visit-preparation.png",
      alt: "HMRC Visit Preparation",
      link: "/hmrc-visit-preparation",
      title: "HMRC Visit Preparation",
      desc: "On 13th March, attendees from across the MSB industry joined an insightful session led by Mr. Ajinkya Patil, Compliance Manager at Calyx Solutions, focusing on how to effectively prepare for HMRC compliance visits. Ajinkya covered the key reasons why HMRC conducts inspections...",
    },
    {
      img: "assets/images/webinars/legal-insights-on-buying-or-leasing-commercial-property.jpg",
      alt: "Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers",
      link: "/legal-insights-on-buying-or-leasing-commercial-property",
      title: " Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers",
      desc: "On 4th December, attendees from various industries joined a session led by Mr. Rohat Kumar, Director of Lumine Solicitors, covering both...",
    },
    {
      img: "assets/images/webinars/dosand-donts-to-get-a-bank-account-for-your-msb-business.png",
      alt: "Do's & Don'ts to get a bank account for your MSB business",
      link: "/dosand-donts-to-get-a-bank-account-for-your-msb-business",
      title: "Do's & Don'ts to get a bank account for your MSB business",
      desc: "On 1st July, MSB professionals across the UK came together for a focused session with Steve Allen, Head of Sales at Clear Junction, to unpack one of the industry's biggest hurdles...",
    },
    {
      img: "assets/images/webinars/how-email-and-mobile-verification-can-cut-customer-onboarding-costs.png",
      alt: "How Email & Mobile Verification Can Cut Customer Onboarding Costs.",
      link: "/how-email-and-mobile-verification-can-cut-customer-onboarding-costs",
      title: "How Email & Mobile Verification Can Cut Customer Onboarding Costs.",
      desc: "In April 2025, we opened the floor—not for a presentation, but for a conversation.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Webinars | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />
        <meta property="og:title" content="Webinars | Money Service Business Advocacy UK" />
        <meta property="og:description" content="" />
        <meta property="og:type" content="website" />
      </Helmet>

      <style>{`
        .course-single-item {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .course-single-item-content-bg {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      `}</style>

      <main className="page_content">
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/learning-hub">Learning Hub</NavLink>
              </li>
              <li className="active">
                <a href="#!">Webinars</a>
              </li>
            </ul>
          </div>
        </section>

        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row justify-content-start">
              {webinars.map((item, index) => (
                <div
                  key={index}
                  className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-4"
                >
                  <div className="course-single-item h-100">
                    <div className="d-block course-single-item-img">
                      <img src={item.img} alt={item.alt} />
                    </div>
                    <div className="course-single-item-content-bg">
                      <div className="course-single-item-content">
                        <h3>
                          <NavLink to={item.link}>{item.title}</NavLink>
                        </h3>
                        <p>{item.desc}</p>
                      </div>
                      <div className="d-flex justify-content-center course-single-item-price-cart">
                        <NavLink
                          to={item.link}
                          className="btn btn-primary btn-hover-secondary"
                        >
                          Read More
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Webinars;
